import { FC } from "react";
import { CommonIconProps } from "../Icon/types";

const Next: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-next"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        d="M18 6.75V17.25"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.925 11.121L6.586 7.15898C5.896 6.72798 5 7.22398 5 8.03798V15.961C5 16.775 5.896 17.272 6.586 16.84L12.924 12.878C13.575 12.473 13.575 11.527 12.925 11.121V11.121Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Next;
